import axios from "axios";
import React, { useState, useEffect } from "react";
import { getCategory, getImage, token } from "../../API";
import EditTagStyles from "../EditTag/EditTagWr";

import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import FileUpload from "../FileUpload";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateMomentUtils from "@date-io/moment";
import { MdOutlineCancel, MdSave } from "react-icons/md";
import { BiEditAlt } from "react-icons/bi";
import EditStyles from "./EditStyles";

const EditPost = ({ data, success, successCallback }) => {
  // getting
  const [makeActive, setMakeActive] = useState(data.active);
  const [texts, setTexts] = useState({
    textUz: data.textUz,
    textUzK: data.textUzK,
    textRu: data.textRu,
    textEn: data.textEn,
  });
  const [title, setTitle] = useState({
    titleUz: data.titleUz,
    titleUzK: data.titleUzK,
    titleEn: data.titleEn,
    titleRu: data.titleRu,
  });
  const [eventTime, setEventTime] = useState(data.eventTime);
  const [timetoView, setTimeToview] = useState(data.timeToView);
  const [imgPath, setImgPath] = useState("NEWS");
  const [link, setLink] = useState(data.link);
  const [active, setActive] = useState("textUz");
  const menus = [
    { t: "textUz" },
    { t: "textUzK" },
    { t: "textEn" },
    { t: "textRu" },
  ];
  // status
  const [important, setImportant] = useState(
    data.status === "IMPORTANT" ? true : false
  );
  // active title
  const [activeTitle, setActivetitle] = useState("titleUz");
  const [titleInput, setTitleInput] = useState("");
  // editing
  const [textBool, setTextBool] = useState("d-block");
  const [inputBool, setInputBool] = useState("d-none");
  const [input, setInput] = useState(EditorState.createEmpty());
  const [cats, setCats] = useState([]);
  const [category, setCategory] = useState(data.category.id);
  // cats
  useEffect(() => {
    const getCats = async () => {
      let reccats = await getCategory();
      setCats(reccats.data.objectKoinot);
    };
    getCats();
  }, []);

  // image
  const [image, setImage] = useState(data.attachment.link);

  const htmlToDraft = (text) => {
    const blocksFromHTML = convertFromHTML(text);

    const content = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    setInput(EditorState.createWithContent(content));
  };

  const viewHandle = (v) => {
    if (v === "d-block") {
      setTextBool("d-none");
      setInputBool("d-block");
    } else {
      setTextBool("d-block");
      setInputBool("d-none");
    }
    setTitleInput(title[activeTitle]);
    htmlToDraft(texts[active]);
  };
  const saveHandle = (path) => {
    if (path == "texts") {
      let oldVals = title;
      oldVals[activeTitle] = titleInput;
      setTitle(oldVals);
      let oldTexts = texts;
      oldTexts[active] = draftToHtml(convertToRaw(input.getCurrentContent()));
      setTexts(oldTexts);
      viewHandle("d-none");
    } else {
      viewHandle("d-none");
    }
  };

  //   change image
  const [changeImgBool, setChangeImgBool] = useState("d-block");
  const [fileBool, setFileBool] = useState("d-none");
  const [img, setImg] = useState(null);
  const [imgBool, setImgBool] = useState("d-none");
  const pictureId = (value) => {
    setImage(value.data.object[0].link);
    setImg(value.data.object[0].fileId);
    setImgBool("d-block");
    cancelHandle();
  };

  const imageHandle = () => {
    setChangeImgBool("d-none");
    setFileBool("d-block");
  };
  const cancelHandle = () => {
    setChangeImgBool("d-block");
    setFileBool("d-none");
  };
  const saveEditedPost = () => {
    let editedPost = {
      id: data.id,
      categoryId: category,
      link: link,
      status: important === true ? "IMPORTANT" : "UNIMPORTANT",
      attachmentId: img !== null ? img : data.attachment.fileId,
      textEn: texts.textEn,
      textRu: texts.textRu,
      textUzK: texts.textUzK,
      textUz: texts.textUz,
      titleEn: title.titleEn,
      titleRu: title.titleRu,
      titleUz: title.titleUz,
      titleUzK: title.titleUzK,
      timeToView: timetoView,
      eventTime: eventTime,
      tagIds: data.tag.map((v) => v.id),
    };
    setData(editedPost);
  };
  const setData = async (body) => {
    const url = `http://164.90.236.174:1988/koinot/news/`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const res = await axios.post(url, body, headers);
      success(true);
      successCallback(`Post o'zgartirildi`, "s");
      return res.data;
    } catch (error) {
      console.error(error);
      successCallback(`Logout qilib qayta kiring`, "e");
      return { error: true, error };
    }
  };

  return (
    <EditStyles>
      <EditTagStyles>
        <div className="row">
          <div className="col-10 border p-3">
            <div className="">
              {menus.map((v, i) => (
                <button
                  key={i}
                  onClick={() => {
                    setActive(v.t);
                    htmlToDraft(texts[v.t]);
                    setTitleInput(Object.values(title)[i]);
                    setActivetitle(Object.keys(title)[i]);
                  }}
                  className={`btn col-3 my-1 ${
                    active === v.t ? "btn-info" : "btn-outline-info"
                  }`}
                >
                  {v.t}
                </button>
              ))}
            </div>
            {/* text va input */}
            <code>Title:</code>
            <h5 className={`${textBool}`}>{title[activeTitle]}</h5>
            <input
              type="text"
              className={`form-control ${inputBool}`}
              value={titleInput}
              onChange={(e) => setTitleInput(e.target.value)}
            />
            <hr />
            <code>Text:</code>
            <div className="w-100 wrapper">
              <p
                className={`${textBool}`}
                dangerouslySetInnerHTML={{ __html: texts[active] }}
              />
            </div>
            <div className={inputBool}>
              <div className="w-100 wrapper">
                <Editor
                  handlePastedText={() => false}
                  editorState={input}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "image",
                      "list",
                      "textAlign",
                      "link",
                      "history",
                    ],
                  }}
                  onEditorStateChange={(e) => {
                    setInput(e);
                  }}
                />
              </div>
            </div>
            <hr />
            <code>Link: </code>
            <h5 className={`${textBool}`}>{link ? link : "link berilmagan"}</h5>
            <input
              type="text"
              className={`w-100 form-control ${inputBool}`}
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <hr />
            {/* category */}
            <code>Category</code>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                defaultValue={category}
                value={category}
                label={cats.length != 0 ? cats[0].textUz : "Kategoriyalar yo'q"}
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                {cats.map((v, i) => (
                  <MenuItem value={v.id} key={i}>
                    {v.textUz}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br /> <br />
            {/* event Time  */}
            <code>Hodisa vaqti</code> <br /> <br />
            <MuiPickersUtilsProvider utils={DateMomentUtils}>
              <DateTimePicker
                value={eventTime}
                onChange={(e) => setEventTime(e.format("yyyy.MM.DD HH:mm"))}
                autoOk
                ampm={false}
                inputVariant="outlined"
                format="yyyy.MM.DD HH:mm"
              />
            </MuiPickersUtilsProvider>
            <hr />
            {/* event Time  */}
            <code>Qo'yilish vaqti</code> <br /> <br />
            <MuiPickersUtilsProvider utils={DateMomentUtils}>
              <DateTimePicker
                value={timetoView}
                onChange={(e) => setTimeToview(e.format("yyyy.MM.DD HH:mm"))}
                autoOk
                ampm={false}
                inputVariant="outlined"
                format="yyyy.MM.DD HH:mm"
              />
            </MuiPickersUtilsProvider>
            <hr />
            {/* status */}
            <code>Status</code>
            <FormControl fullWidth>
              <Select
                id="demo-simple-select"
                defaultValue={important}
                value={important}
                label={"Statusni tanlang"}
                onChange={(e) => {
                  setImportant(e.target.value);
                }}
              >
                <MenuItem value={false}>Dolzarb emas</MenuItem>
                <MenuItem value={true}>Dolzarb</MenuItem>
              </Select>
            </FormControl>{" "}
          </div>
          {/* edit, cancel, save, delete*/}
          <div className="col-2 border p-2 d-flex">
            <span className={`${textBool} w-100`}>
              <button
                className="btn btn-info col-12"
                onClick={() => {
                  viewHandle("d-block");
                  setTitleInput(title[activeTitle]);
                }}
              >
                <BiEditAlt className="text-white" />
              </button>
            </span>

            <span className={`${inputBool} w-100`}>
              <button
                className="btn btn-warning col-12"
                onClick={() => viewHandle("d-none")}
              >
                <MdOutlineCancel className="text-danger" />
              </button>
              <button
                onClick={() => saveHandle("texts")}
                className="btn btn-success  col-12"
              >
                <MdSave className="text-white" />
              </button>
            </span>
          </div>
          {/* edit, cancel, save, delete*/}
        </div>

        <div className="row border">
          <div className="col-10 border">
            <p className="fw-bold my-2">Image</p>
            <img src={image} alt="" className={`img-fluid`} />
          </div>
          <div className="col-2 border">
            <p className="fw-bold my-2">Rasmni o'zgartirish</p>
            <span className={`${changeImgBool} col-12 `}>
              <button
                className="btn btn-info col-6 my-2 mx-auto"
                onClick={imageHandle}
              >
                Change image
              </button>
            </span>
            <span className={`${fileBool} w-100`}>
              <button
                onClick={cancelHandle}
                className={`btn btn-warning col-6 my-2`}
              >
                <MdOutlineCancel className="text-white" />
              </button>

              <FileUpload
                callback={pictureId}
                path={imgPath}
                came={img !== null ? true : false}
                className="w-100"
              />
              <p className={`text-success ${imgBool}`}>Rasm almashtirildi</p>
            </span>
          </div>
        </div>

        <button onClick={saveEditedPost} className="btn btn-info col-12">
          Saqlash
        </button>
      </EditTagStyles>
    </EditStyles>
  );
};

export default EditPost;



// WEBPACK FOOTER //
// ./src/Components/EditPost/index.js